export const CACHE_KEYS = {
  USER_INFO: 'user_info',
  TOKEN: 'token',
  REFRESH_TOKEN: 'refresh_token',
  IS_COOKIE_SET_UP: 'is_cookie_set_up',
  LOGIN_METHOD: 'login_method',
};

export const SESSION_STORAGE_KEYS = {
  SSO_EMAIL: 'sso_email',
  LOGIN_REDIRECT_PATH: 'login_redirect_path',
  JOURNEY_ID: 'journey_id',
  TENANT_CONFIG: 'tenant_config',
};
